import {
  Layout,
  Button,
  Input,
  message,
  Table,
  ConfigProvider,
  Row,
  Col,
  Popconfirm,
  Statistic,
  Pagination,
  Modal,
  Popover,
} from 'antd'
import { Content } from 'antd/lib/layout/layout'
import zhCN from 'antd/lib/locale/zh_CN'
import OAMSider from '../oam-sider'
import React, { useEffect, useRef, useState } from 'react'
import { sendHttpPostRequest } from '../../../api/http-request'
import Cookies from 'js-cookie'

import Draggable from 'react-draggable'
import idataCourseTableStyles from '../../common/global-styles/idatacoding.module.less'
import GlobalCss from '@/global.module.less'
import { BACKEND_API_URL } from '../../../constants/constants'
import UserCard from '../user/oam-userinfo-card'

const { Search } = Input
const { TextArea } = Input

export interface Props {}

/** OAM 镜像列表页 */
export const OAMImageList: React.FC<Props> = (props) => {
  const [imageResult, setImageResult] = useState([] as any[]) // 当前显示的结果页
  const [resultSum, setResultSum] = useState(0) // 搜索返回的结果数
  const [totalCount, setTotalCount] = useState(0) // 搜索返回的结果数
  const queryContent = useRef('') // 记录搜索串
  const order = useRef('') // 排序升序降序
  const order_by = useRef('') // 排序列
  const page = useRef(1) // 记录当前的页数
  const pageSize = useRef(10) // 记录当前每页展示数量

  /* 创建实验相关 */
  const [isModalVisible, setIsModalVisible] = useState(false)
  const draggleRef = useRef<HTMLDivElement | null>(null)
  const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
  const [disabled, setDisabled] = useState(true)

  const [imageName, setImageName] = useState('')
  const [imageDescription, setImageDescription] = useState('')
  const [imageServeUrl, setImageServeUrl] = useState('')


  useEffect(() => {
    queryImageList()
  }, [])

  /**
   * 查询镜像列表
   */
  const queryImageList = () => {
    sendHttpPostRequest(
      'course/api/oam_query_project_environment',
      {
        sessionid: Cookies.get('sessionid'),
        query: queryContent.current,
        //source: querySource.current,
        page: page.current,
        pagesize: pageSize.current,
        order: order.current,
        order_by: order_by.current,
      },
      queryImageListCallback
    )
  }

  /**
   * 查询镜像列表回调
   * @param response
   */
  const queryImageListCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      window.location.href = '/oam_login?next=oam_image_list'
    } else if (response.code == 0) {
      // 成功
      setImageResult(response.data.list)
      setResultSum(response.data.total_sum)
      setTotalCount(response.data.total_count)
    } else if (response.code == -501) {
      // 权限不足
      window.location.href = '/oam_login?next=oam_image_list'
    } else {
      message.error(response.message)
    }
  }

 

  // 创建镜像回调
  const createImageCallback = (response: any) => {
    //console.log(response)
    message.destroy()
    if (response.is_ok) {
      message.success(response.message)
      queryImageList()
      // window.open(response.url)
    } else {
      message.error(`创建镜像失败${response.message}`)
    }
  }

  /**
   * 点击创建镜像
   */
  const createImage = () => {
    message.destroy()
    const requestParams = {
      sessionid: Cookies.get('sessionid'),
      name: imageName,
      description: imageDescription,
      server_url: imageServeUrl,
    }
    sendHttpPostRequest(
      'course/api/oam_create_project_environment',
      requestParams,
      createImageCallback
    )
  }

  const onStart = (event: any, uiData: any) => {
    const { clientWidth, clientHeight } = window?.document?.documentElement
    const targetRect = draggleRef?.current?.getBoundingClientRect()
    if (targetRect) {
      setBounds({
        left: -targetRect?.left + uiData?.x,
        right: clientWidth - (targetRect?.right - uiData?.x),
        top: -targetRect?.top + uiData?.y,
        bottom: clientHeight - (targetRect?.bottom - uiData?.y),
      })
    }
  }

  const handleOk = () => {
    //确认创建实验
    message.destroy()
    if (imageName.trim() == '') {
      message.error('请输入镜像名称')
    }else {
      createImage()
      setIsModalVisible(false)
    }
  }

  const showModal = () => {
    //setCover(null as any)
    setIsModalVisible(true)
  }

  const handleCancel = () => {
    setIsModalVisible(false)
  }

  // 镜像名称改变
  const onNameChange = (key: string, event: any) => {
    setImageName(event.target.value)
  }

  // 镜像描述改变
  const onDescriptionChange = (key: string, event: any) => {
    setImageDescription(event.target.value)
  }

  // 镜像服务地址改变
  const onServeUrlChange = (key: string, event: any) => {
    setImageServeUrl(event.target.value)
  }



  //页码和页数发生了变化
  const onPageChange = (newPage: number, newPageSize?: number | undefined) => {
    page.current = newPage ? newPage : 1
    if (newPageSize) {
      pageSize.current = newPageSize
    }
    queryImageList()
  }

  // 删除回调
  const onDeleteBtnClickCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 没登录
      window.location.href = '/oam_login?next=oam_image_list'
    } else if (response.code == -501) {
      // 没权限
      window.location.href = '/oam_login?next=oam_imagelist'
    } else if (response.code == 0) {
      message.success(response.message)
      queryImageList()
    } else {
      message.error(response.message)
      queryImageList()
    }
  }

  // 点击 删除
  const onDeleteBtnClick = (imageId: string) => {
    sendHttpPostRequest(
      'course/api/oam_delete_project_environment',
      {
        sessionid: Cookies.get('sessionid'),
        environment_id: imageId,
      },
      onDeleteBtnClickCallback
    )
  }

  // 渲染操作
  const renderActions = (text: any, record: any) => {

      return (
        <Row
          justify="center"
          align="middle"
          style={{ gap: '10px' }}
          wrap={false}
        >
          <Col>
            <Button
              style={{ borderRadius: 20, fontSize: 14 }}
              size="small"
              id="editit"
              type="dashed"
              onClick={() => {
                window.open('/oam_image_preview?image_id=' + record.id)
              }}
            >
              {' '}
              预览
            </Button>
          </Col>
          {/* <Col>
            <Button
              style={{ borderRadius: 20, fontSize: 14 }}
              size="small"
              id="editit"
              type="dashed"
              onClick={onEditBtnClick.bind(this, record.id)}
            >
              {' '}
              编辑
            </Button>
            </Col> */}

          <Col>

          <Popconfirm
                placement="top"
                title={'确认删除镜像"' + record.name + '"吗？'}
                onConfirm={onDeleteBtnClick.bind(this, record.id)}
                okText="确认"
                cancelText="取消"
              >
              <Button
                style={{ borderRadius: 20, fontSize: 14 }}
                size="small"
                id="deleteexe"
                type="dashed"
                danger
                
              >
                {' '}
                删除
              </Button>
            </Popconfirm>
          </Col>
        
        </Row>
      )
     
  }

  //点击了编辑按钮
  const onEditBtnClick = (id: any, event: any) => {
    window.open('/oam-image-edit?image_id=' + id)
  }

  //点击了搜索按钮
  const onSearchBtn = (value: string) => {
    page.current = 1
    queryContent.current = value
    queryImageList()
  }



  // 表格发生变化
  const onTableChange: any = (
    pagination: any,
    filters: any,
    sorter: any,
    extra: { currentDataSource: []; action: any }
  ) => {
    if (sorter.order) {
      //如果选择了排序列
      order.current = sorter.order
      order_by.current = sorter.field
    }
    
    page.current = 1
    queryImageList()
  }

  const columns: any = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      align: 'left',
      width: 100,
      ellipsis: true,
    },
    {
      title: '镜像名称',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      align: 'left',
      width: 150,
      render: (t, r, i) => (
        <span
          className={GlobalCss.link}
          onClick={() =>
            window.open('/oam_image_preview?image_id=' + r.id)
          }
        >
          {t}
        </span>
      ),

    },
    {
      title: '镜像描述',
      dataIndex: 'description',
      key: 'description',
      ellipsis: true,
      align: 'left',
      width: 150,
      render: (t, r, i) => (
        <span
        >
          {t}
        </span>
      ),

    },
    {
      title: '服务地址',
      dataIndex: 'server_url',
      key: 'server_url',
      ellipsis: true,
      align: 'left',
      width: 150,
      render: (t, r, i) => (
        <span >
          {t}
        </span>
      ),

    },

 
    {
      title: '创建者',
      dataIndex: 'creator_name',
      key: 'creator_name',
      align: 'left',
      width: 150,
      ellipsis: true,
      render: (text, record) => {
        return (
          <Row align="middle" wrap={false}>
            <Col flex="40px">
              <Popover
                arrowPointAtCenter={true}
                trigger="hover"
                placement="left"
                content={<UserCard user_id={record?.creator_id} />}
                title={null}
              >
                <img
                  onMouseOver={() => {}}
                  style={{
                    width: 30,
                    height: 30,
                    borderRadius: 15,
                    cursor: 'pointer',
                  }}
                  src={
                    record?.creator_avatar?.startsWith('http')
                      ? record?.creator_avatar
                      : BACKEND_API_URL + record?.creator_avatar
                  }
                />
              </Popover>{' '}
            </Col>
            <Col flex="auto">
              <span>{text}</span>
            </Col>
          </Row>
        )
      },
    },
    {
      title: '创建时间',
      dataIndex: 'create_time',
      key: 'create_time',
      align: 'center',
      width: 180,
      sorter: true,
      ellipsis: true,
      sortDirections: ['descend', 'ascend'],
      defaultSortOrder: 'descend',
    },
    {
      title: '操作',
      dataIndex: 'actions',
      key: 'actions',
      width: 330,
      ellipsis: true,
      align: 'center',
      fixed: 'right',
      render: renderActions,
    },
  ]

  return (
    <Layout style={{ minHeight: '100vh',minWidth:1200 }}>
      <OAMSider keys={['21']} openKeys={['sub-project']}/>
      <Layout style={{ backgroundColor: '#f9f9f9' }}>
        <Content
          style={{
            backgroundColor: '#fff',
            borderRadius: 5,
            minWidth: 400,
            margin: 30,
            paddingTop: 20,
          }}
        >
          <div style={{ paddingLeft: 30, paddingRight: 30, paddingBottom: 30 }}>
            <Row align="middle" gutter={16}>
              <Col flex="80px">
                <Statistic title="全部镜像" value={totalCount} />
              </Col>
              <Col flex="250px">
                <Search
                  placeholder="搜索镜像 ID/名称/描述"
                  style={{ width: 350 }}
                  enterButton={true}
                  onSearch={onSearchBtn}
                  className={idataCourseTableStyles.oamSearch}
                />
              </Col>
              <Col flex="auto" style={{ textAlign: 'right' }}>
                <Button
                  type="primary"
                  style={{ float: 'right', marginRight: 20, borderRadius: 20, textShadow:'none', boxShadow:'none' }}
                  onClick={showModal}
                >
                  创建镜像
                </Button>
                <ConfigProvider locale={zhCN}>
                  <Modal
                    title={
                      <div
                        style={{
                          width: '100%',
                          cursor: 'move',
                        }}
                        onMouseOver={() => {
                          if (disabled) {
                            setDisabled(false)
                          }
                        }}
                        onMouseOut={() => {
                          setDisabled(true)
                        }}
                        onFocus={() => {}}
                        onBlur={() => {}}
                        // end
                      >
                        创建镜像
                      </div>
                    }
                    closable={false}
                    open={isModalVisible}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    bodyStyle={{ minHeight: '300px' }}
                    destroyOnClose={true}
                   // width={508}
                    modalRender={(modal) => (
                      <div style={{width:600}} 
                      //className={caseStyles.createDiv}
                      >
                        <Draggable
                          disabled={disabled}
                          bounds={bounds}
                          onStart={(event, uiData) => onStart(event, uiData)}
                        >
                          <div ref={draggleRef}>{modal}</div>
                        </Draggable>{' '}
                      </div>
                    )}
                  >
                    <Row
                      gutter={[8, 8]}
                      justify="start"
                      align="middle"
                      style={{ marginBottom: 20 }}
                    >
                      <Col
                        flex="100px"
                        style={{ textAlign: 'left', marginLeft: 50 }}
                      >
                        镜像名称
                      </Col>
                      <Col flex="auto" style={{ textAlign: 'left' }}>
                        <Input
                          maxLength={40}
                          onChange={onNameChange.bind(this, 'name')}
                          //className={caseStyles.caseName}
                          placeholder="请输入镜像名称"
                          required={true}
                          style={{ width: '100%' }}
                        />
                      </Col>
                      <Col flex="100px"></Col>
                    </Row>

                    <Row
                      gutter={[8, 8]}
                      justify="start"
                      align="middle"
                      style={{ marginBottom: 20 }}
                    >
                      <Col
                        flex="100px"
                        style={{ textAlign: 'left', marginLeft: 50 }}
                      >
                        服务地址
                      </Col>
                      <Col flex="auto" style={{ textAlign: 'left' }}>
                        <Input
                          maxLength={40}
                          onChange={onServeUrlChange.bind(this, 'serve_url')}
                          //tyles.caseName}
                          placeholder="请输入服务地址"
                          required={true}
                          style={{ width: '100%' }}
                        />
                      </Col>
                      <Col flex="100px"></Col>
                    </Row>

                    <Row
                      gutter={[8, 8]}
                      justify="start"
                      align="top"
                      style={{ marginBottom: 20, maxHeight: 120 }}
                    >
                      <Col
                        flex="100px"
                        style={{ textAlign: 'left', marginLeft: 50 }}
                      >
                        镜像描述
                      </Col>
                      <Col flex="auto" style={{ textAlign: 'left' }}>
                        <TextArea
                          //className={caseStyles.caseText}
                          showCount
                          maxLength={300}
                          rows={4}
                          onChange={onDescriptionChange.bind(
                            this,
                            'description'
                          )}
                          placeholder="请输入镜像描述"
                          required={true}
                          style={{ width: '100%', maxHeight: 100 }}
                        />
                      </Col>
                      <Col flex="100px"></Col>
                    </Row>

                  </Modal>
                </ConfigProvider>
              </Col>
            </Row>



            <div style={{minHeight:500}}  className={idataCourseTableStyles.tableWrapper}>
              <ConfigProvider locale={zhCN}>
                <Table
                  dataSource={imageResult}
                  columns={columns}
                  rowKey={(record) => record.case_id}
                  pagination={false}
                  scroll={{ x: 800 }}
                  onChange={onTableChange}
                />
              </ConfigProvider>
            </div>
  

            <ConfigProvider locale={zhCN}>
              <div
                style={{ marginBottom: 30,}}
                className={'css.pagination'}
              >
                <Pagination
                  defaultCurrent={1}
                  total={resultSum}
                  defaultPageSize={10}
                  current={page.current}
                  hideOnSinglePage={true}
                  onChange={onPageChange}
                  showQuickJumper={true}
                  showSizeChanger={false}
                  //showTotal={(total) => `共 ${total} 镜像`}
                  //pageSizeOptions={['10', '20', '50', '100']}
                />
              </div>
            </ConfigProvider>
          </div>
        </Content>

      </Layout>
    </Layout>
  )
}

export default OAMImageList
